<template>
    <div id="userTab">


        <div v-if="statusUpdateSuccessMsg" class="text-green">{{ statusUpdateSuccessMsg }}</div>
        
        
        <LocationUsersList v-if="isMenteesPanelVisible" 
            card_title="Mentees"
            :count="menteesCount" 
            :itemLength="menteesItems.length" 
            :lessResult="lessMenteesItems" 
            :allItems="menteesItems" 
            :show_more="show_more_mentees"
            :see_more_text="see_more_mentees_text"
            @click="showMoreMentees"
            ref="mentees_list"
            :isResponseStatus="isResponseStatus"
            :readOnly="readOnly"
            :loading="loading"
            :isCanAddTransfer="isCanAddTransfer"
            :accountId="accountId">
        </LocationUsersList>

        <LocationUsersList  
            card_title="Mentors"
            :count="mentorsCount" 
            :itemLength="mentorsItems.length" 
            :lessResult="lessMentorsItems" 
            :allItems="mentorsItems" 
            :show_more="show_more_mentors"
            :see_more_text="see_more_mentors_text"
            @click="showMoreMentors"
            :isResponseStatus="isResponseStatus"
            ref="mentors_list"
            :readOnly="readOnly"
            :loading="loading"
            :isCanAddTransfer="isCanAddTransfer"
            :accountId="accountId">
        </LocationUsersList>

        <LocationUsersList  
            card_title="Managers"
            :count="managersCount" 
            :itemLength="managersItems.length" 
            :lessResult="lessManagersItems" 
            :allItems="managersItems" 
            :show_more="show_more_managers"
            :see_more_text="see_more_managers_text"
            @click="showMoreManagers"
            :isResponseStatus="isResponseStatus"
            ref="managers_list"
            :readOnly="readOnly"
            :loading="loading"
            :isCanAddTransfer="isCanAddTransfer"
            :accountId="accountId">
        </LocationUsersList>
        
    </div>
</template>
<script>
import axios from 'axios';
import LocationUsersList from './location_users_list.vue';

export default {
    props: ['accountId', 'readOnly'],
    data() {
        return {
            isListPanel: true,
            displayMentees: [],
            lessManagersItems: [],
            lessMentorsItems: [],
            lessMenteesItems: [],
            lessApprenticesItems: [],
            managersItems: [],
            mentorsItems: [],
            menteesItems: [],
            apprenticesItems: [],
            managersCount: 0,
            mentorsCount: 0,
            menteesCount: 0,
            apprenticesCount: 0,
            see_more_managers_text: 'See all',
            see_more_mentors_text: 'See all',
            see_more_mentees_text: 'See all',
            see_more_apprentices_text: 'See all',
            show_more_managers: false,
            show_more_mentors: false,
            show_more_mentees: false,
            show_more_apprentices: false,
            isApprenticesPanelVisible: false,
            isMenteesPanelVisible: false,
            program: '',
            userId: '',
            statusUpdateSuccessMsg: '',
            isResponseStatus: false,
            isCanAddTransfer: false,
        }
    },
    components: {
        LocationUsersList,
    },
    methods: {
        scrollTop() {
            let element = document.getElementById('userTab');    
            element.scrollIntoView(true);
        },
        getListofAllUsers() {
            this.loading = true;
            this.allUsers = [];
            this.managersItems = [];
            this.mentorsItems = [];
            this.menteesItems = [];
            this.apprenticesItems = [];
            this.managersCount = 0;
            this.mentorsCount = 0;
            this.menteesCount = 0;
            this.apprenticesCount = 0;
            axios('/enterprise-admin/location/users',
            {
                method: 'GET',
                params: {
                    account_id: this.accountId,
                }
            })
            .then(resp => {
                this.loading = false;
                this.isResponseStatus = true;
                this.program = resp.data.program;
                this.isCanAddTransfer = resp.data.isCanAddTransfer;
                this.allUsers = resp.data.allUsers;
                this.managersCount = this.allUsers.managers.length;
                this.mentorsCount = this.allUsers.mentors.length;
                this.menteesCount = this.allUsers.mentees.length;
                this.apprenticesCount = this.allUsers.apprentices.length;
                this.managersItems = this.allUsers.managers;
                this.mentorsItems = this.allUsers.mentors;
                this.menteesItems = this.allUsers.mentees;
                this.apprenticesItems = this.allUsers.apprentices;
                if(this.managersCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessManagersItems[i] = this.allUsers.managers[i];
                    }
                }
                else {
                    for( var j=0; j< this.managersCount; j++) {
                        this.lessManagersItems[j] = this.allUsers.managers[j];
                    }
                }
                if(this.mentorsCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessMentorsItems[i] = this.allUsers.mentors[i];
                    }
                }
                else {
                    for( var j=0; j< this.mentorsCount; j++) {
                        this.lessMentorsItems[j] = this.allUsers.mentors[j];
                    }
                }
                if(this.menteesCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessMenteesItems[i] = this.allUsers.mentees[i];
                    }
                }
                else {
                    for( var j=0; j< this.menteesCount; j++) {
                        this.lessMenteesItems[j] = this.allUsers.mentees[j];
                    }
                }
                if(this.apprenticesCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessApprenticesItems[i] = this.allUsers.apprentices[i];
                    }
                }
                else {
                    for( var j=0; j< this.apprenticesCount; j++) {
                        this.lessApprenticesItems[j] = this.allUsers.apprentices[j];
                    }
                }
                if (this.program == 'Apprenticeship' || this.program == 'Mentorship & Apprenticeship') {
                    this.isApprenticesPanelVisible = true;
                }
                if (this.program == 'Mentorship' || this.program == 'Mentorship & Apprenticeship') {
                    this.isMenteesPanelVisible = true;
                }
                this.clearFlashMessage();
            })
            .catch(() => {
            });
        },
        showMoreManagers() {       
            if (!this.show_more_managers) {
                this.show_more_managers = true;
                this.see_more_managers_text = 'See less';
            } else {
                this.show_more_managers = false;
                this.see_more_managers_text = 'See all';
            }
        },
        showMoreMentors() {
            if (!this.show_more_mentors) {
                this.show_more_mentors = true;
                this.see_more_mentors_text = 'See less';
            } else {
                this.show_more_mentors = false;
                this.see_more_mentors_text = 'See all';
            }
        },
        showMoreMentees() {
            if (!this.show_more_mentees) {
                this.show_more_mentees = true;
                this.see_more_mentees_text = 'See less';
            } else {
                this.show_more_mentees = false;
                this.see_more_mentees_text = 'See all';
            }
        },
        showMoreApprentices() {
            if (!this.show_more_apprentices) {
                this.show_more_apprentices = true;
                this.see_more_apprentices_text = 'See less';
            } else {
                this.show_more_apprentices = false;
                this.see_more_apprentices_text = 'See more';
            }
        },
        navigate(userId) {
            this.$parent.navigateUserDetail(userId, this.accountId);
        },
        clearFlashMessage() {
            setTimeout(() => {
                this.statusUpdateSuccessMsg = '';
            }, 2000);
        }
    },
    created(){
        this.getListofAllUsers();
    }
}
</script>
<style scoped>
.text-green { color: #28a745 !important; font-weight: 900; }
.users_heading_1 { width: 55%; cursor: pointer; }
.users_heading_2 { width: 15%; }
.users_heading_3 { width: 15%; } 
.users_heading_4 { width: 15%; font-weight: 900; }
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/users_tab.vue